<!-- 
  Este arquivo é um exemplo de edit de algum model.
  Por si só o edit é só uma casca que coloca o form dentro e tem as queries e mutations para criação do registro no banco, assim como o new.
  Por isso ele não tem muito código, basicamente a importação do form.vue
  Esse componente serve como edit e como show, quando o readOnly for true.
-->
<template>
  <!-- 
    O BaseEdit é um componente padrão utilizado em todas as telas do tipo edit para facilitar o desenvolvimento. 
    Porém, é importante notar que tudo é enviado para esse componente e ele é quem renderiza o form.
  -->
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    
    :editIcon="editIcon"
    :readOnly="readOnly"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :isTextButton="isTextButton"
    :textButton="textButton"
    :editButtonTooltipTop="editButtonTooltipTop"
    :buttonColor="buttonColor"
    width="60%"
  >
  <!-- :editTitle="editTitle"
    :readTitle="readTitle" -->

    <!-- esse é o slot padrão que está no baseEdit para renderizar o form -->
    <template slot="editForm">
      <!-- esse form é o arquivo form.vue que vai conter os campos que serão renderizados na tela -->
      <Form
        ref="form"
        v-if="!loading"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :readOnly="readOnly"
        :partialReadOnly="partialReadOnly"
        @installment-update="loadServerEntry(entry.id)"
        :allowPasswordEditing="allowPasswordEditing"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag'; //importacao do gql para queries e mutations do GraphQL
import Form from "./form.vue"; //importacao do form que vai ser renderizado dentro do new
import BaseEdit from "@shared_components/base_edit.vue"; //importacao do baseEdit
// import BasePrint from "@shared_components/base_print.vue"; //importação do componente para impressão

export default {
  data() {
    return {
      loading: true, //indica se a tabela está carregando
      pageLoading: false, //indica se a tela está em carregando
      editableEntry: null, //variavel que vai representar o objeto que vai ser editado no edit
      formErrors: [], //lista de erros que podem ocorrer quando o usuario salva o novo objeto
      extraData: null, //dados extras que devem ser enviados para o edit, como por exemplo listas que vão ser utiizadas em selects
      partialReadOnly: false, //utilizado quando o form é readOnly mas tem exceções
      allowPasswordEditing: false,
    };
  },
  // as props são propriedades utilizadas para passar informação de um componente para outro
  // se definir tipo, essa variavel passa ser tipada, evitando erros de tipo
  // se definir valor default, esses valores são assumidos caso o componente pai não passe valor pra essa variavel
  props: {
    entry: Object,
    // editTitle: {
    //   type: String,
    //   default: "Edição de Usuário"
    // },
    // readTitle: {
    //   type: String,
    //   default: "Visualização de Usuário"
    // },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    editButtonTooltipTop: {
      type: Boolean,
      default: true
    },
    buttonColor: {
      type: String,
      default: "rgba(0,0,0,.54)"
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Usuário"
    },
  },
  // registros dos componentes
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    // BasePrint: BasePrint
  },
  created() {
  },
  methods: {
    // método utilizado para carregar os dados do registro que será editado
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_USER_QUERY,
          fetchPolicy: "no-cache", 
          variables: {
            id: id,
            supervisorId: this.entry.person.id,
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.user;
          this.extraData = response.data; //estou sempre fornecendo todos os dados da query pro extraData, assim o edit vai ter todas as informações necessários
          // aqui é um exemplo do que pode ser feito para deixar o edit como partialReadOnly
          if (this.editableEntry.canBeDeleted === false) {
            this.partialReadOnly = true;
          } else {
            this.partialReadOnly = false;
          }

          this.extraData.accountContext.allUsersCandidate.push({id: this.editableEntry.person.id, name: this.editableEntry.person.name});
          // se precisar imprimir o registro que retornou do banco
          // console.log("cashOutflow edit", this.editableEntry);

          // permite editar a senha somente do usuario logado
          this.getCurrentUser(user => {
            if (user.id == id) {
              this.allowPasswordEditing = true;
            }
          });
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    
    // vai chamar o mutation para atualizar o chashOutFlow no servidor
    updateServerEntry: function(user) {
      this.pageLoading = true;
      console.log("user", user);
      var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(user, user.validations);
      console.log("filtered", filtered);
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_MUTATION,
          variables: {
            input: filtered
          }
        })
        .then(response => {
          //recebe os erros que retornaram do server, se nao tiver nenhum a lista está vazia
          var errors = response.data.updateUser.errors

          if (errors.length){ //se tiver erros, estes sao salvos na variavel que controla os erros e enviados para o baseNew que exibe isso para o usuário
            this.formErrors = errors
          } else {
            //se nao tiver erro significa que o registro foi atualizado
            //dai: 
            // fecha o modal do edit
            this.$refs.baseEdit.closeDialog();
            //emite um sinal de que houve a atualização de um objeto
            // esse sinal será capturado pelo index, que vai ser atualizado
            this.$emit("entry-updated");
            // reseta o formulario para limpar os campos e as validações
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },

    updateUserForUser: function(user) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_FOR_USER_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(user, user.validations)
          }
        })
        .then(response => {
          //recebe os erros que retornaram do server, se nao tiver nenhum a lista está vazia
          var errors = response.data.updateUserForUser.errors

          if (errors.length){ //se tiver erros, estes sao salvos na variavel que controla os erros e enviados para o baseNew que exibe isso para o usuário
            this.formErrors = errors
          } else {
            //se nao tiver erro significa que o registro foi atualizado
            //dai: 
            // fecha o modal do edit
            this.$refs.baseEdit.closeDialog();
            //emite um sinal de que houve a atualização de um objeto
            // esse sinal será capturado pelo index, que vai ser atualizado
            this.$emit("entry-updated");
            // reseta o formulario para limpar os campos e as validações
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },

    // função que será executada quando o usuário clicar no botão de salvar a edição realizada
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        // se o form estiver valido, verifica qual dos mutations precisa ser chamado
        if (this.$can('create', 'UserForAdmin') || this.$can('create', 'User')){
          this.updateServerEntry(this.editableEntry);
        } else {
          this.updateUserForUser(this.editableEntry);
        }
      }
    },
    //funcao para resetar o form
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    //funcao para limpar os erros do servidor que sao exibidos para o usuario
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

//exemplo de query do edit do objeto
const LOAD_USER_QUERY = gql `
  query ($id: ID!, $supervisorId: ID!) {
    accountContext {
      user(id: $id) {
        id
        email
        password
        personId
        person {
          id
          name
        }
        personAttributes {
          name
          isSupervisor
          subordinateIds
        }
        person {
          id
          name
          subordinateIds
        }
        accountId
        account {
          id
          name
        }
        roleId
        isActive
        validations
      }
      allAccounts {
        id
        name
      }
      allUsersCandidate {
        id
        name
      }
      allPosibleSubordinates(supervisorId: $supervisorId){
        id
        name
      }
    }
    globalContext {
      allRoles {
        id
        name
        text
        description
      }
    }
  }
`;

//exemplo de mutation para atualizar o objeto no banco
const UPDATE_USER_MUTATION = gql `
  mutation($input: UserUpdateInputObject!) {
    updateUser(input: $input) {
      user {
        id
      }
      errors
    }
  }
`;

const UPDATE_USER_FOR_USER_MUTATION = gql `
  mutation($input: UserUpdateInputObject!) {
    updateUserForUser(input: $input) {
      user {
        id
      }
      errors
    }
  }
`;


</script>

<style scoped></style>
